import styled from 'styled-components';
import colors from '_colors.module.scss';
import { Link } from 'react-router-dom';

export const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BreadcrumbItem = styled.div`
  display: flex;
  align-items: center;
`;

export const BreadcrumbSeparator = styled.div`
  display: flex;
  align-items: center;
  margin: 0 4px;

  bds-icon {
    color: ${colors.ContentGhost};
  }
`;

export const BreadcrumbLink = styled(Link)`
  bds-typo {
    color: ${colors.ContentGhost};
  }
`;
